import React from "react";
import { Link, useLocation } from "react-router-dom";
import tataMotorImage from '../../../Assets/Images/image.png'
function TMLSubNavbar() {
    const location = useLocation();

    return (
        <>
            {location.pathname !== "/" && location.pathname !== "/dashboard" &&
                <nav className="navbar navbar-expand-sm sticky-top navbar-light"
                    style={{ zIndex: 3, backgroundColor: "#0A4742", color: "white" }}>

                    {/* Logo on the left */}
                    <Link className="navbar-brand shadow-lg" to="/dashboard">
                        <img
                            src={tataMotorImage}
                            alt="Tata Motors Logo"
                            style={{ height: "50px", marginLeft: "10px", backgroundColor: 'white', borderRadius: '50px' }}
                        />
                    </Link>

                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="">
                            <div style={{ width: "30px", height: "3px", backgroundColor: "white", margin: "6px" }}></div>
                            <div style={{ width: "30px", height: "3px", backgroundColor: "white", margin: "6px" }}></div>
                            <div style={{ width: "30px", height: "3px", backgroundColor: "white", margin: "6px" }}></div>
                        </span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mx-auto">
                            <li className="nav-item">
                                <Link className="nav-link" to='/TMLModelPerformance'>
                                    <button
                                        className={location.pathname === "/TMLModelPerformance" ? "btnsubnavbarselected" : "btnsubnavbar"}
                                    >
                                        Model Performance
                                    </button>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link">
                                    <button
                                        className={location.pathname === "/marketanalysis" || location.pathname === "/attamarketanalysis" ? "btnsubnavbarselected" : "btnsubnavbar"}
                                        onClick={() => alert('Functionality Needs to come')}>
                                        Market Analysis
                                    </button>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/TMLSimulator">
                                    <button
                                        className={location.pathname === "/TMLSimulator" ? "btnsubnavbarselected" : "btnsubnavbar"}>
                                        LSM Planner
                                    </button>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link">
                                    <button
                                        className={location.pathname === "/savedscenarios" || location.pathname === "/attasavedscenarios" ? "btnsubnavbarselected" : "btnsubnavbar"}
                                        onClick={() => alert('Functionality Needs to come')}>
                                        Saved Scenarios
                                    </button>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link">
                                    <button
                                        className={location.pathname === "/savedreports" ? "btnsubnavbarselected" : "btnsubnavbar"}
                                        onClick={() => alert('Functionality Needs to come')}>
                                        Saved Reports
                                    </button>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>}
        </>
    );
}

export default TMLSubNavbar;
